window.addEventListener('DOMContentLoaded', function () {
  'use strict';

  const elmBody = $('body');

  // ハンバーガーメニュー
  $('.js-nav-toggle').on('click', function () {
    let
      spNav = $('.o-mobile-nav-wrapper'),
      hamburger = $('.icon-hamburger'),
      close = $('.icon-close');

    if ($(this).hasClass('is-opened')) {
      elmBody.css('overflow', 'auto');
      spNav.add(close).fadeOut();
      hamburger.fadeIn();
    } else {
      elmBody.css('overflow', 'hidden');
      spNav.add(close).fadeIn();
      hamburger.fadeOut();
    }
    $(this).add(elmBody).toggleClass('is-opened');
  });

  // スクロール時のヘッダー
  let pos = 0;
  $(window).on('scroll', function () {
    const
      HEADER = $('#shopify-section-header'),
      TOP_HEADER = $('.switch-logo-wrap'),
      BOTTOM_HEADER = $('.o-site-header'),
      ACCESSIBLE_NAV = $('#AccessibleNav');

    let
      currentPos = $(this).scrollTop(),
      headerHeight = HEADER.outerHeight(),
      topHeaderHeight = TOP_HEADER.outerHeight(),
      bottomHeaderHeight = BOTTOM_HEADER.outerHeight(),
      spTopHeaderHeight = topHeaderHeight + bottomHeaderHeight + ($(window).width() * 0.163);

    if (!elmBody.hasClass('is-opened')) {
      if ($(window).width() > 749) {
        // PC
        // 上へスクロールしたらヘッダーを表示, 下へスクロールしたらヘッダーを非表示
        if (currentPos < pos) {
          if (currentPos === 0) {
            HEADER.css('top', 0);
          } else if (currentPos < topHeaderHeight) {
            HEADER.css('top', 0);
          } else {
            HEADER.css('top', -topHeaderHeight);
          }
        } else {
          if (currentPos === 0) {
            HEADER.css('top', 0);
          } else {
            HEADER.css('top', -headerHeight);
          }
        }
      } else {
        // SP
        if (currentPos < pos) {
          if (currentPos < 30) {
            HEADER.css('top', 0);
          } else {
            HEADER.css('top', -topHeaderHeight);
          }

        } else {
          if (currentPos < 30) {
            HEADER.css('top', 0);
          } else {
            HEADER.css('top', -spTopHeaderHeight);
          }
        }
      }
      pos = currentPos;
    }
  });

  // ハンバーガーメニュー サブメニュー
  let menuCount = 0;
  $('.js-toggle-submenu').on('click', function () {
    let
      target = $(this).data('target'),
      menuWrap = $('.o-mobile-nav-wrapper');

    if ($(this).hasClass('mobile-nav__return-btn')) {
      $(this).closest('.mobile-nav__dropdown').css('right', '-100%');
      menuCount--;
    } else {
      let parent = $('[data-parent="' + target + '"]');
      parent.css({
        // 'height': parent.outerHeight(),
        'right': 0,
        'overflow-y': 'auto'
      });
      menuCount++;
    }

    if (menuCount === 0) {
      menuWrap.css('overflow-y', 'auto');
    } else {
      menuWrap.css('overflow-y', 'hidden');
    }
  });

  
  // 20221021
  // モーダルをbody直下へ移動
  if($('.js-login-attention').length > 0) {
    $('.js-login-attention').prependTo('body');
  }

  // ログインページモーダル
  $('.js-login-attention-close').on('click', function () {
    $('.login-attention-area-wrap').fadeOut();
    $('.template-customers-login').css({
      'overflow': 'inherit',
      'height': 'inherit',
    });

    let m = 1209600;
    document.cookie = "modal=true;max-age=" + m;
  });

  // cookieがあったらモーダルを非表示
  if (!document.cookie.split(';')
    .some((item) => item.includes('modal=true'))) {
    $('.js-login-attention').css('opacity', '1');
  } else {
    $('.js-login-attention').hide();
    $('.template-customers-login').css({
      'overflow': 'inherit',
      'height': 'inherit',
    });
  }

  // ログイン画面表示
  $('.js-login-page-btn').on('click', function () {
    $('.js-cart-attention-area').hide();
    $('.js-login-from').show();
  });

  // カートページからログインページへ遷移した時の処理
  const ref = document.referrer;
  if (location.pathname === '/account/login') {
    if (ref.indexOf('/cart') !== -1 ) {
      $('.js-cart-attention-area').show();
      $('.js-login-from').hide();
    }
  }

    $('.js-global-menu').hover(function() {
    if($(window).width() > 749) {
      $(this).find('.js-mega-menu').show();
    }
  }, function() {
    $('.js-mega-menu').stop().hide();
  });

  $('.js-mega-menu-close').on('click', function () {
    $('.js-mega-menu').stop().hide();
  });

  // fixed lineバナーをclose
  $('.js-close-linebnr').on('click', function () {
    $('.fixed-lineaccount').stop().fadeOut();
  });

  // TOP 人気ランキング リンクが付与されるので削除
  $('.template-index .collection-tabs-ranking .js-tab-panel > a, .template-index .collection-tabs-ranking .tab-wrap > a').removeAttr('href');

  // 商品詳細 おすすめ商品 限定販売の商品を削除
  (function() {
    const targetNode = document.querySelector('.template-product #related-products');
    if(!targetNode) return;
    
    // おすすめ商品エリアの子要素追加を監視
    const callback = (mutationsList, observer) => {
      mutationsList.forEach(mutation => {
        if (mutation.type === 'childList') {
          const data = targetNode.dataset.hidden;
          if (!data) return;

          // データ属性に付与されたhandleと一致した商品は削除
          const handles = data.split(',');
          $.each($("#related-products .relation-products a"), function() {
            const href = $(this).attr('href');
            if(handles.some(handle => href.includes(handle))) {
              $(this).closest('.related-product-card').remove();
            }
          });
        }
      });
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, {
      childList: true, //子要素の追加/削除を監視
      subtree: true, //子孫要素も監視対象にする
    });
  })();

});
